import { httpV2 } from "../http.js";

const ChecklistsService = {
    list: (criteria = {}) => {
        const params = new URLSearchParams(criteria).toString();
        return httpV2.get(`/checklists${params ? `?${params}` : ""}`);
    },
    get: (checklistId) => httpV2.get(`/checklists/${checklistId}`),
    create: (checklist) => httpV2.post("/checklists", checklist),
    update: (checklistId, data) => httpV2.put(`/checklists/${checklistId}`, data),
    delete: (checklistId) => httpV2.delete(`/checklists/${checklistId}`),
    clone: (checklistId) => httpV2.post(`/checklists/${checklistId}/clone`),
};

export default ChecklistsService;
